import { ComponentType, createElement } from 'react';
import StateContext from '~/ui/react/contexts/state';
import state from '~/state';

/**
 * Creates component instances wrapped with global context
 *
 * @param component
 * @param props
 */
export default function elementFactory(component: ComponentType, props: object) {
    return <StateContext.Provider value={state}>
        {createElement(component, props)}
    </StateContext.Provider>;
}
